if (!customElements.get('gift-wrap-upsell')) {
  customElements.define(
    'gift-wrap-upsell',
    class GiftWrapUpsell extends HTMLElement {
      connectedCallback() {
        this.variantId = parseInt(this.dataset.variantId);
        this.checkbox = this.querySelector('.gift-wrap__checkbox');
        this.checkbox.addEventListener('change', this.onToggle.bind(this));
        this.syncWithCart();
      }

      async syncWithCart() {
        try {
          const response = await fetch('/cart.js');
          const cart = await response.json();
          const inCart = cart.items.some((item) => item.variant_id === this.variantId);
          this.checkbox.checked = inCart;
        } catch (_) {}
      }

      async onToggle(event) {
        this.classList.add('gift-wrap--loading');
        try {
          if (event.target.checked) {
            await this.addToCart();
          } else {
            await this.removeFromCart();
          }
          await this.refreshCartUI();
        } catch (_) {
          event.target.checked = !event.target.checked;
        } finally {
          this.classList.remove('gift-wrap--loading');
        }
      }

      async addToCart() {
        const formData = new FormData();
        formData.append('id', this.variantId);
        formData.append('quantity', 1);

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        });

        if (!response.ok) throw new Error('Add to cart failed');
      }

      async removeFromCart() {
        const formData = new FormData();
        formData.append('id', this.variantId);
        formData.append('quantity', 0);

        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        });

        if (!response.ok) throw new Error('Remove from cart failed');
      }

      async refreshCartUI() {
        try {
          const response = await fetch(
            `${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`
          );
          const sections = await response.json();
          const parser = new DOMParser();

          const cartDrawerEl = document.getElementById('CartDrawer');
          if (cartDrawerEl && sections['cart-drawer']) {
            const parsed = parser.parseFromString(sections['cart-drawer'], 'text/html');
            const inner = parsed.querySelector('.shopify-section');
            if (inner) cartDrawerEl.innerHTML = inner.innerHTML;
          }

          const bubbleEl = document.getElementById('cart-icon-bubble');
          if (bubbleEl && sections['cart-icon-bubble']) {
            const parsed = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
            const inner = parsed.querySelector('.shopify-section');
            if (inner) bubbleEl.innerHTML = inner.innerHTML;
          }
        } catch (_) {}
      }
    }
  );
}
